__turbopack_context__.v({
  "alert-banner": "course-limited-access-module-scss-module__3NJB3W__alert-banner",
  "content": "course-limited-access-module-scss-module__3NJB3W__content",
  "heading": "course-limited-access-module-scss-module__3NJB3W__heading",
});
